/* One send path for the site's enquiry forms (Contact page, Gifts page corporate quote, bottle request): our own email endpoint (team email + customer thank-you),
   with Shopify's own contact email as the fallback so nothing is lost.
   LLEnquiry(form, { url, data(formData) -> object, busy(on), ok(), bad(message) })
   LLCaptcha(form) -> Promise<token>: a Cloudflare Turnstile token for each send/upload (the Vercel endpoints check it).
   LLCaptcha.mount(form): shows the visible "Verify you are human" tick box above the form's submit button (LLEnquiry does this itself). */
(() => {
if (window.LLEnquiry) return; // pages can load this file more than once (two bottle forms)
const LL_TURNSTILE_KEY = '0x4AAAAAAFdSBu2fXMyEjWMe'; // Cloudflare Turnstile widget 'Liquor Library forms' (admin@aioperations.co.nz account), secret = Vercel TURNSTILE_SECRET
let llTurnstile;
const load = () => (llTurnstile ||= new Promise((ok, no) => {
  window.llTurnstileReady = ok;
  const s = document.createElement('script');
  s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=llTurnstileReady&render=explicit'; s.async = true; s.onerror = no;
  document.head.append(s);
}));
const boxes = new WeakMap(); // form -> { id, token, waiting }
const mount = (form) => load().then(() => {
  let b = boxes.get(form); if (b) return b;
  b = { token: null, waiting: [] }; boxes.set(form, b);
  const el = document.createElement('div');
  el.style.cssText = 'grid-column:1/-1;margin:.2rem 0';
  const btn = [...form.querySelectorAll('button, input[type=submit]')].find((x) => x.type === 'submit'); btn ? btn.before(el) : form.append(el);
  const settle = (t, e) => { b.token = t; b.waiting.splice(0).forEach(([ok, no]) => (t ? ok(t) : no(e))); };
  b.id = window.turnstile.render(el, { sitekey: LL_TURNSTILE_KEY, size: 'flexible', theme: 'light', callback: (t) => settle(t),
    'expired-callback': () => { b.token = null; }, 'error-callback': () => settle(null, new Error('captcha')), 'timeout-callback': () => window.turnstile.reset(b.id) });
  return b;
});
// each token works once: hand it over, then reset the box so the next send/upload gets a fresh tick
window.LLCaptcha = (form) => mount(form).then((b) => new Promise((ok, no) => {
  const take = (t) => { b.token = null; window.turnstile.reset(b.id); ok(t); };
  if (b.token) take(b.token); else b.waiting.push([take, no]);
}));
window.LLCaptcha.mount = (form) => { mount(form).catch(() => {}); };

window.LLEnquiry = (form, o) => {
  window.LLCaptcha.mount(form);
  let viaShopify = false;
  // capture phase on document: runs before Shopify's hCaptcha listener on contact forms, which would post the form first
  document.addEventListener('submit', async (ev) => {
    if (ev.target !== form || viaShopify || !o.url) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    o.busy(true);
    try {
      const body = { ...o.data(new FormData(form)), captcha: await window.LLCaptcha(form) };
      const r = await fetch(o.url, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) });
      const j = await r.json().catch(() => ({}));
      if (r.status === 400) { o.bad(j.error); o.busy(false); return; } // their typo: let them fix it
      if (!r.ok || !j.ok) throw new Error(j.error || 'send');
      o.ok();
    } catch (e) {
      viaShopify = true;
      form.requestSubmit(); // fallback: Shopify contact email (with its captcha)
    }
    o.busy(false);
  }, true);
};
})();
